import { DatePicker, Form, Input, InputNumber, Select, Checkbox, Radio, TimePicker } from 'antd';
import { StateSwitch } from '@monorepo/shared-components';
import { INPUT_TYPE, REGEX } from '@monorepo/config';
import React from 'react';

export function FormInput(props) {
  const { type, formItemOptions, inputOptions, inputChildren } = props;

  const renderInput = (type) => {
    switch (type) {
      case INPUT_TYPE.TEXT_AREA:
        return <Input.TextArea {...inputOptions} />;
      case INPUT_TYPE.NUMBER:
        return <InputNumber {...inputOptions} />;
      case INPUT_TYPE.CURRENCY_INPUT:
        return (
          <InputNumber
            {...inputOptions}
            controls={false}
            maxLength={50}
            formatter={(value) => value.replace(REGEX.CURRENCY, '.')}
            parser={(value) => value.replace(REGEX.CURRENCY_PARSER, '')}
          />
        );
      case INPUT_TYPE.SELECT:
        return <Select {...inputOptions}>{inputChildren}</Select>;
      case INPUT_TYPE.DATE_PICKER:
        return <DatePicker {...inputOptions} />;
      case INPUT_TYPE.PASSWORD:
        return <Input.Password {...inputOptions} />;
      case INPUT_TYPE.CHECK_BOX:
        return <Checkbox {...inputOptions}>{inputChildren}</Checkbox>;
      case INPUT_TYPE.RADIO_GROUP:
        return <Radio.Group {...inputOptions}>{inputChildren}</Radio.Group>;
      case INPUT_TYPE.TIME_PICKER:
        return <TimePicker {...inputOptions} />;
      case INPUT_TYPE.SWITCH:
        return <StateSwitch {...inputOptions} />;
      default:
        return <Input {...inputOptions} />;
    }
  };

  return <Form.Item {...formItemOptions}>{renderInput(type)}</Form.Item>;
}

export default FormInput;
